import { create } from "zustand";

export const useCertificateStore = create((set) => ({
  currentCertificate: {},
  setCurrentCertificate: (currentCertificate) => set({ currentCertificate }),
}));